export default __webpack_public_path__ + "static/kusuma-8341c1a0b004ed7cbfc8c7b1ed562393.png";